import React from 'react';

import opcLogo from 'styles/assets/svg/opc-logo.svg';

import classes from './OpcHeader.module.scss';

export const OpcHeader = () => {
    return (
        <div className={classes.OpcHeader}>
            <img className={classes.image} src={opcLogo} alt={'icon'} />
            <div className={classes.text}>
                <div className={classes.title}>Oracle Primavera Cloud</div>
                <div className={classes.subtitle}>
                    Set up a secure Oracle Primavera Cloud connection for schedule import and export
                </div>
            </div>
        </div>
    );
};
